const DashboardRoutes = {
  getDashboardStats: 'dashboard',
};

export default DashboardRoutes